import axios from 'axios';
import authHeader from "@/service/AuthHeader";
import getEnvironment from "@/service/Environment";

const API_LOGGED_IN_URL = getEnvironment().API_LOGGED_IN_URL + 'admin';

export default class AdminService {
    getAll() {
        return axios.get(API_LOGGED_IN_URL + '/list', { headers: authHeader() });
    }

    get(id) {
        return axios.get(API_LOGGED_IN_URL + `/view/${id}`, { headers: authHeader() });
    }

    create(data) {
        const header = Object.assign({'Content-Type': 'application/json'}, authHeader());
        return axios.post(API_LOGGED_IN_URL + '/registration', data, { headers:  header });
    }

    generatePassword(id) {
        return axios.get(API_LOGGED_IN_URL + `/generate-password/${id}`, { headers: authHeader() });
    }

    update(id, data) {
        return axios.put(API_LOGGED_IN_URL + `/update/${id}`, data, { headers: authHeader() });
    }

    delete(id) {
        return axios.delete(API_LOGGED_IN_URL + `/delete/${id}`, { headers: authHeader() });
    }
}
